import { useVar } from './useVar';

export function useTimeout<T extends (...args: any[]) => any>(
  callback: T,
  ms?: number,
) {
  let timeoutId = useVar<null | number>(null);

  function start() {
    timeoutId = setTimeout(callback, ms);
  }

  function clear() {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  }

  function restart() {
    if (timeoutId) {
      clear();
      start();
    }
  }

  function startOrRestart() {
    if (timeoutId) {
      restart();
    } else {
      start();
    }
  }

  return {
    start,
    clear,
    restart,
    startOrRestart,
  };
}
